import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import Loader from '../../components/Loader'
import { getById } from '../../lib/RestApi/customApiHandler'
import AddAllowanceType from './AddAllowanceType'
export default function EditAllowanceType() {
  const params = useParams()
  const [allowanceType, setAllowanceType] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getById('/allowance/type', params.allowanceTypeId).then((res) => {
      setAllowanceType(res)
      setLoading(false)
    })
  }, [params.allowanceTypeId])

  return <> {loading ? <Loader /> : <AddAllowanceType allowanceType={allowanceType} />} </>
}
